<template>
  <div v-if="data && data.items" :id="id" :class="className" :style="{ height: height, width: width }" />
  <div v-else :style="{ height: height, width: width, lineHeight: height }" style="text-align: center;color: #909399;font-size:0.8rem;">暂无数据</div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '200px'
    },
    title: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    range: {
      type: Number,
      default: 1
    },
    timeInterval: {
      type: String,
      default: 'minutes'
    },
    tagName: {
      type: Array,
      default: () => {
        return []
      }
    },
    unit: {
      type: String,
      default: ''
    },
    dateFormat: {
      type: String,
      default: 'MM-DD HH:mm'
    },
    seriesType: {
      type: String,
      default: 'line'
    },
    chartType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      chart: null,
      showLabel: []
    }
  },
  watch: {
    data() {
      this.buildData()
    }
  },
  mounted() {
    this.buildData()
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    // 生成数据
    buildData() {
      var that = this
      var data = that.data
      if (!data || !data.items) {
        return
      }

      var items = that.data.items

      var columLabel = that.tagName
      that.getTimeList(data.time_begin, data.time_end)
      var columName = that.showLabel
      var columnValue = []
      var arrData = []
      var columTagLabel = []
      for (var i = 0; i < columLabel.length; i++) {
        arrData = []
        var col = columLabel[i]
        columTagLabel.push(col.name)
        if (that.chartType === 'days') {
          for (var k = 0; k < columName.length; k++) {
            var item_day = items[col.field]
            arrData.push(item_day.points[k] ? item_day.points[k] : 0)
          }
        } else {
          var itemsIndex = that.findArrayIndex(col.field, items)
          for (var j = 0; j < columName.length; j++) {
          // var item = items[col.field]
          // var item = items[i]
            if (itemsIndex === -1) {
              arrData.push(0)
            } else {
              var item = items[itemsIndex]
              arrData.push(item.points[j] ? item.points[j] : 0)
            }
          }
        }
        // eslint-disable-next-line no-eval
        columnValue.push(eval('(' + ("{'name':'" + col.name + "','type':'" + that.seriesType + "',smooth: true,'symbol': 'circle','symbolSize': 5," +
            "'showSymbol': false,'lineStyle': {'normal': { 'width': 1.3 }},'data':[" + arrData + ']}') + ')'))
      }

      that.$nextTick(function() {
        that.buildChart(columTagLabel, columName, columnValue)
      })
    },
    // 生成图形
    buildChart(columLabel, columName, columnValue) {
      var that = this
      if (that.chart) {
        that.chart.dispose()// 销毁
      }
      that.chart = echarts.init(document.getElementById(that.id))

      var option = {
        // color: ['#68E6C1', '#fac858'],
        title: {
          text: that.title,
          textStyle: {
            // 文字颜色
            color: '#9e9e9e',
            // 字体大小
            fontSize: 14
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function(params, ticket, callback) {
            var htmlStr = '<div style="font-size: 12px;">'
            for (var i = 0; i < params.length; i++) {
              htmlStr += '<div>'
              var param = params[i]
              var xName = param.name// x轴的名称
              var seriesName = param.seriesName// 图例名称
              var value = param.value// y轴值
              if (i === 0) {
                htmlStr += xName + '<br/>'// x轴的名称
              }
              // 为了保证和原来的效果一样，这里自己实现了一个点的效果
              htmlStr += param.marker
              // 圆点后面显示的文本
              htmlStr += seriesName
              htmlStr += '<span style="font-size: 14px;color: #000;font-weight: bold;margin-left: 20px">' + that.$util.thousandSeparator(value) + '</span>'
              if (that.unit) {
                htmlStr += ' ' + that.unit
              }
              htmlStr += '</div>'
            }
            htmlStr += '</div>'
            return htmlStr
          }
        },
        legend: {
          // orient 设置布局方式，默认水平布局，可选值：'horizontal'（水平） ¦ 'vertical'（垂直）
          orient: 'horizontal',
          // x 设置水平安放位置，默认全图居中，可选值：'center' ¦ 'left' ¦ 'right' ¦ {number}（x坐标，单位px）
          x: 'right',
          // y 设置垂直安放位置，默认全图顶端，可选值：'top' ¦ 'bottom' ¦ 'center' ¦ {number}（y坐标，单位px）
          y: 'top',
          icon: 'rect', // 形状  类型包括 circle，rect,line，roundRect，triangle，diamond，pin，arrow，none
          itemWidth: 12, // 设置宽度
          itemHeight: 12, // 设置高度
          itemGap: 20, // 设置间距
          data: columLabel
        },
        grid: {
          left: '5%',
          right: '4%',
          bottom: '12%',
          containLabel: true
        },
        xAxis: {
          min: 0,
          type: 'category',
          // axisLabel: {
          //   showMaxLabel: true
          // },
          data: columName
        },
        yAxis: {
          min: 0,
          minInterval: 1,
          type: 'value'
        },
        dataZoom: [{
          type: 'inside'
        }],
        series: columnValue
      }

      that.chart.setOption(option)
    },
    getTimeList(start, end) {
      var that = this
      if (!start || !end) {
        return
      }
      that.showLabel = []
      var format2 = that.dateFormat
      var startTime = that.$moment(start)
      var endTime = that.$moment(end)
      if (that.chartType !== 'days') {
        startTime = that.$moment(startTime).add(that.range, that.timeInterval)
      }
      while (that.$moment(startTime).valueOf() <= that.$moment(endTime).valueOf()) {
        that.showLabel.push(that.$moment(startTime).format(format2))
        startTime = that.$moment(startTime).add(that.range, that.timeInterval)
      }
    },
    findArrayIndex(name, arr) {
      if (!name) {
        return -1
      }
      var index = -1
      for (let i = 0; i < arr.length; i++) {
        const element = arr[i]
        if (element.tag === name) {
          index = i
          break
        }
      }
      return index
    }
  }
}
</script>
